export const GET_PROJECT_CRITERIA_KEYS_AND_THEMATICS =
  'GET_PROJECT_CRITERIA_KEYS_AND_THEMATICS';

export function getProjectCriteriaKeysAndThematics(data) {
  return {
    type: GET_PROJECT_CRITERIA_KEYS_AND_THEMATICS,
    data,
  };
}
